import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';

const featureFlagName = 'merchant-admin-merchant-venues-v4-api';

export const useIsMerchantVenuesV4ApiEnabled = (isMerchantFetchEnabled = true) => {
  const { user, isEmployee } = useUser();
  const { data: isMerchantVenuesV4ApiEnabledFeatureFlag, isLoading: isLoadingIsMerchantVenuesV4ApiEnabled } =
    useFeatureFlags(
      [featureFlagName],
      {
        user_id: user?.id ?? '',
        user_email: user?.email ?? '',
        user_country: user?.country ?? '',
        is_employee: isEmployee,
      },
      { enabled: isMerchantFetchEnabled },
    );
  const isMerchantVenuesV4ApiEnabled =
    !isLoadingIsMerchantVenuesV4ApiEnabled && isMerchantVenuesV4ApiEnabledFeatureFlag?.[featureFlagName] === 'on';

  return { isMerchantVenuesV4ApiEnabled, isLoadingIsMerchantVenuesV4ApiEnabled };
};
